import { fetchAssessment } from "../actions/assessment.action";
import { fetchAssessmentResponces } from "../actions/questionAnswer.action";
import { BaseEvent } from "./base.event";

export class AssessmentEvent extends BaseEvent {
  constructor(store) {
    super(store);
    // this.registerEvent("CREATE_ASSESSMENT", this.syncAssessments);
    // this.registerEvent("REMOVE_ASSESSMENT", this.syncAssessments);
    // this.registerEvent("ASSESSMENT_PUBLISHED", this.syncAssessments);
  }

  // syncAssessments = async ({ classId }) => {
  //   if (classId !== JSON.parse(sessionStorage.getItem("classinfo")).kneuraId)
  //     return;
  //   await this.dispatchAction(fetchAssessment(classId));
  //   await this.dispatchAction(fetchAssessmentResponces(classId, localStorage.getItem("kneuraId")));
  // };
}
